/*/
 * Anchor
 *
 * Target: href | data-target
 * Align:  start | center | end | nearest
 *
/*/
	const siteAnchor = document.querySelectorAll('[site-anchor]')

	if (siteAnchor) {
		siteAnchor.forEach(e => {
			e.addEventListener('click', _ => {
				_.preventDefault()

				const dataTarget = e.dataset.target
				const hrefTarget = e.getAttribute('href')
				const dataAlign = e.dataset.align ? e.dataset.align : 'start'

				if (dataTarget) {
					const element = document.querySelector(dataTarget)
					scrollToTarget(element, 600)

					// document.querySelector(dataTarget).scrollIntoView({
					// 	behavior: 'smooth',
					// 	block: dataAlign,
					// 	inline: 'nearest'
					// })
				} else if (hrefTarget) {
					const element = document.querySelector(hrefTarget)
					scrollToTarget(element, 600)

					// document.querySelector(hrefTarget).scrollIntoView({
					// 	behavior: 'smooth',
					// 	block: dataAlign,
					// 	inline: 'nearest'
					// })
				}
			})
		})
	}


/*/
 * Anchor reload
 *
 * Target: href | data-target
 * Align:  start | center | end | nearest
 *
/*/
	const siteAnchorReload = document.querySelectorAll('[site-anchor-reload]')

	if (siteAnchorReload) {
		siteAnchorReload.forEach(e => {
			e.addEventListener('click', _ => {
				const dataTarget = e.dataset.target

				window.localStorage.setItem('site_anchor_reload', dataTarget)
			})
		})
	}

	window.addEventListener('load', _ => {
		setTimeout(() => {
			const savedTarget = window.localStorage.getItem('site_anchor_reload')

			if (savedTarget && document.querySelector(savedTarget)) {
				// document.querySelector(savedTarget).scrollIntoView({
				// 	behavior: 'smooth',
				// 	block: 'start',
				// 	inline: 'nearest',
				// })

				const element = document.querySelector(savedTarget)
				scrollToTarget(element, 500)

				window.localStorage.removeItem('site_anchor_reload')
			}
		}, 500);
	})


/**
 * Smooth Scroll
 */
	window.scrollToTarget = function (target, duration = 500) {
		const top = target.getBoundingClientRect().top
		const startPos = window.pageYOffset
		const diff = top

		let startTime = null
		let requestId

		const loop = function (currentTime) {
			if (!startTime) {
				startTime = currentTime
			}

			const time = currentTime - startTime

			const percent = Math.min(time / duration, 1)
			window.scrollTo(0, startPos + diff * percent)

			if (time < duration) {
				requestId = window.requestAnimationFrame(loop)
			} else {
				window.cancelAnimationFrame(requestId)
			}
		}

		requestId = window.requestAnimationFrame(loop)
	}
